import Quill from 'quill'

function isDeleteSpace(
  retain: number,
  ogDelta: { ops: { insert: string | {} }[] }
) {
  const ogStr = ogDelta.ops.reduce((pre, cur) => {
    let { insert } = cur
    if (typeof insert !== 'string') {
      insert = '@'
    }
    return pre + insert
  }, '')

  if (ogStr[retain] === ' ') return true
}

export default (editor: Quill, args: any[]) => {
  const [type] = args

  if (type !== 'text-change') return

  const [, { ops }, ogDelta] = args,
    [retainObj, deleteObj] = ops as [
      { retain: number },
      { delete: number } | undefined
    ]

  if (deleteObj && deleteObj.delete === 1) {
    const { retain } = retainObj
    if (!isDeleteSpace(retain, ogDelta)) {
      return
    }

    const deleteIdx = retainObj.retain - 1,
      { ops } = editor.getContents(deleteIdx)

    if (ops[0] && ops[0].insert) {
      const obj = ops[0].insert as { INSERT_FILE?: {} }
      if (obj.INSERT_FILE) {
        editor.deleteText(deleteIdx, 1)
      }
    }
  }
}
